<template>
    <div class="addCardWrap">
        <!-- <nav-bar></nav-bar> -->
        <div class="fc ac">
            <div class="bindCard fc">
                <div class="row fc bb">
                    <span>请输入激活码</span>
                    <input v-model="code" type="text" />
                </div>
                <div class="row fc">
                    <span>手机号</span>
                    <input type="text" />
                </div>
            </div>
            <button @click="bindVipCard" class="confirmBtn">确定</button>
        </div>
    </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
import { Toast } from 'mint-ui';
export default {
    data() {
        return {
            code: ''
        };
    },
    components: {
        navBar
    },
    methods: {
        bindVipCard(){
            if (!this.code){
                Toast({
                    message: "请输入激活码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            }
            this.$post({
                method: 'member.coupon.vipcard.bind',
                auth_code: this.getLocal('auth_code'),
                cardpass: this.code
            }).then(res => {
                if (res.success){
                    Toast({
                        message: "添加成功",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                }
            })
        }
    }
};
</script>
<style scoped lang="scss">
.addCardWrap {
    .bindCard {
        width: 710px;
        margin-top: 30px;
        background-color: #fff;
        border-radius: 15px;
        .row {
            padding: 0 50px 34px;
            font-size: 28px;
            span {
                height: 90px;
                line-height: 90px;
            }
            input {
                height: 70px;
                width: 100%;
                padding: 0 20px;
                background-color: #eff1f2;
                border-radius: 10px;
            }
        }
    }
    .confirmBtn {
        width:198px;
        height:78px;
        line-height:78px;
        border:1px solid #fe5200;
        color:#fe5200;
        border-radius:10px;
        background-color: #f2f2f2;
        margin-top: 50px;
        font-size: 30px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/me/addVipCard.vue